import Header from '../components/header'

export default function NoPage() {
    return (
        <>
            <Header />
            <h2>Error 404: Page does not exist</h2>
        </>
    )
}